import React, { useEffect, useState, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../config/fbconfig";
import BlogItem from "../components/blog/blogitem";
import PageTitle from "../banner";

function BlogList({ Id }) {
  const [formattedData, setFormattedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const docRef = doc(db, "Other", "Blog");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const fetchedData = Object.entries(docSnap.data()).map(
            ([key, value]) => {
              const date = new Date(
                value.Date.seconds * 1000 + value.Date.nanoseconds / 1000000
              );
              return {
                Id: key,
                ...value,
                formattedDate: date.toLocaleString(),
              };
            }
          );
          setFormattedData(fetchedData.sort((a, b) => a.Priority - b.Priority));
        } else {
          setFormattedData([]);
        }
      } catch (error) {
        console.error("Error fetching blogs: ", error);
      }
    };
    fetchBlogs();
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = formattedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(formattedData.length / itemsPerPage);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bgImage, setBgImage] = useState(
    isMobile ? "img/about/blogmb.jpg" : "img/about/banner03.jpg"
  );

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setBgImage(
        window.innerWidth <= 768
          ? "img/about/blogmb.jpg"
          : "img/about/banner03.jpg"
      );
    };

    const debounceResize = debounce(handleResize, 100);

    window.addEventListener("resize", debounceResize);
    return () => {
      window.removeEventListener("resize", debounceResize);
    };
  }, []);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  return (
    <div>
      <div style={{ marginBottom: "5rem" }}>
        <PageTitle desc={"Blog"} img={bgImage} />
      </div>
      <section className="blog-section spad">
        <div style={{ padding: "2rem" }}>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              {currentItems.map((item) => (
                <BlogItem key={item.Id} {...item} />
              ))}
              <div className="blog-pagination">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (number) => (
                    <a
                      key={number}
                      href="#!"
                      onClick={() => handlePageChange(number)}
                      className={number === currentPage ? "active" : ""}
                    >
                      {number}
                    </a>
                  )
                )}
                {currentPage < totalPages && (
                  <a
                    href="#!"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

BlogList.propTypes = {
  Id: PropTypes.string,
};

export default BlogList;
